var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fora-do-ar" }, [
    _c("div", { staticClass: "conteudo" }, [
      _c("div", { staticClass: "textos" }, [
        _vm._m(0),
        _c("div", { staticClass: "sub-titles" }, [
          _c("div", { staticClass: "btn-voltar", on: { click: _vm.goHome } }, [
            _c("span", [_vm._v("Voltar para página inicial")])
          ]),
          _c("div", { staticClass: "divider" }),
          _vm._m(1)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h1", [_vm._v("404")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "textos-sub-titles" }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("Ocorreu um error 404!")
      ]),
      _c("span", [
        _vm._v("A página que você tentou acessar não esta disponível.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }